'use client';

import dynamic from 'next/dynamic';
import type { PlaceholderType } from './types';
import { PlaceholderTypes } from './types';

const DynamicComponentContactForm = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_ContactForm' */ '../Forms/Contact/ContactForm.client').then(
      (mod) => mod.ContactForm,
    ),
  { ssr: false },
);

const DynamicRateProtectionForm = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_RateProtectionForm' */ '../Forms/RateProtection/RateProtectionForm.client'
    ).then((mod) => mod.RateProtectionForm),
  { ssr: false },
);

const DynamicRevocationForm = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_RevocationForm' */ '../Forms/Revocation/RevocationForm.client'
    ).then((mod) => mod.RevocationForm),
  { ssr: false },
);

const DynamicBraFinder = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_BraFinder' */ '../BraFinder/BraFinder.client').then(
      (mod) => mod.BraFinder,
    ),
  { ssr: false },
);

const DynamicPaybackCoupons = dynamic(
  () =>
    import(
      /* webpackChunkName: 'CMS_PaybackCoupons' */ '../CmsPaybackCoupons/CmsPaybackCoupons.client'
    ).then((mod) => mod.CmsPaybackCoupons),
  { ssr: false },
);

export const Placeholder = ({ data }: { data: PlaceholderType }) => {
  const { field_placeholder_variants: variant } = data;

  switch (variant as PlaceholderTypes) {
    case PlaceholderTypes.RevocationForm:
      return <DynamicRevocationForm />;
    case PlaceholderTypes.ContactForm:
      return <DynamicComponentContactForm />;
    case PlaceholderTypes.RateProtectionType:
      return <DynamicRateProtectionForm />;
    case PlaceholderTypes.BraFinder:
      return <DynamicBraFinder />;
    case PlaceholderTypes.PaybackCoupons:
      return <DynamicPaybackCoupons data={data} />;
    default:
      return null;
  }
};
